<template>
  <b-modal
    id="modal-maintenance"
    ref="modal-maintenance"
    size="lg"
    title=""
    centered
    hide-header
    hide-footer
    modal-class="transparent-modal"
    @hide="onHide"
  >
    <div class="maintenance-wrapper">

      <!-- close button -->
      <button class="maintenance-close" @click="closeMaintenanceModal">
        ×
      </button>

      <!-- maintenance html -->
      <div v-html="maintenance"></div>

      <!-- checkbox -->
      <div class="maintenance-checkbox" v-if="login === false">
        <b-form-checkbox v-model="hideToday">
          ไม่ต้องแสดงอีกในวันนี้
        </b-form-checkbox>
      </div>

    </div>
  </b-modal>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BModal,
  BButton,
  BFormTextarea,
  BCard,
  BFormCheckbox,
} from "bootstrap-vue";

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BButton,
    BModal,
    BFormTextarea,
    BCard,
    BFormCheckbox,
  },
  props: {
    maintenance: {
      type: String,
      default: "",
    },
    login: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      hideToday: false,
    };
  },
  created() {
    console.log("ModalMaintenance.Show");
  },
  // mounted() {
  //   const today = new Date().toISOString().split("T")[0];
  //   const hiddenDate = localStorage.getItem("maintenance_hide_until");
  //   if (hiddenDate !== today) {
  //     this.$bvModal.show("modal-maintenance");
  //   }
  // },
  methods: {
    onCancel() {
      this.$refs["modal-maintenance"].hide();
    },
    setMaintenanceHidden() {
      const today = new Date().toISOString().split("T")[0];

      localStorage.setItem("maintenance_hide_until", today);
    },
    closeMaintenanceModal() {
      if (this.hideToday) {
        this.setMaintenanceHidden();
      }

      this.$bvModal.hide("modal-maintenance");
    },
    onHide(bvEvent) {
      const isBackdrop = bvEvent.trigger === "backdrop";

      if (isBackdrop && this.hideToday) {
        this.setMaintenanceHidden();
      }
    },
  },
};
</script>

<style>
.transparent-modal .modal-content {
  background: transparent;
  border: 0;
  box-shadow: none;
}

.transparent-modal .modal-body {
  padding: 0;
}

.maintenance-wrapper {
  position: relative;
}

/* ปุ่ม X */
.maintenance-close {
  position: absolute;
  top: 12px;
  right: 12px;

  width: 36px;
  height: 36px;

  border: none;
  border-radius: 50%;

  background: rgba(255, 255, 255, 0.9);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.15);

  font-size: 24px;
  line-height: 1;
  cursor: pointer;

  z-index: 10;
}

.maintenance-checkbox {
  display: flex;
  justify-content: center;

  margin-top: 1rem;
  padding-bottom: 0.5rem;

  font-size: 0.95rem;
  color: #64748b;
}
</style>
